import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RTLProvider = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set initial direction
    document.documentElement.dir = i18n.dir();
    document.documentElement.lang = i18n.language;

    // Listen for language changes
    const handleLanguageChange = () => {
      document.documentElement.dir = i18n.dir();
      document.documentElement.lang = i18n.language;
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return children;
};

export default RTLProvider; 